import { Component, OnInit, Input } from '@angular/core';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-documentApiSubscriptions',
  templateUrl: './documentApiSubscriptions.component.html',
  styleUrls: ['./documentApiSubscriptions.component.css']
})
export class DocumentApiSubscriptionsComponent implements OnInit {

  isSaving = false;
  @Input() currentProject: any;
  @Input() currentApiId: any;
  currentConfiguration: any;
  currentLocationName: string;
  selectedLocation: any;
  docsCollection = new Array<any>();

  constructor(private _adminService: AdminServiceService, private _alertify: AlertifyService) { }

  ngOnInit() {

    console.log("ON INIT: ", this.currentProject.id);

    if (!this.currentProject)
      return;

    if (this.currentProject.id  <= 0)
    {
      this.currentConfiguration = {
        id: 0,
        name: "",
        contentLocations: new Array<any>()
      };
    }
    else {
      console.log("CurrentProject: ", this.currentProject);
      //Load Current Configuration....
      console.log('loading configuration...');
      this._adminService.getDocsConfiguration(this.currentProject.apiKey).subscribe(response => {     
        console.log('loaded data: ', response);

        if (response) {
          
          this.currentConfiguration = response;

          if (!this.currentConfiguration.contentLocations)
          {
            this.currentConfiguration.contentLocations = new Array<any>();
          }

        } else {
          this.currentConfiguration = {
            id: 0,
            name: "",
            contentLocations: new Array<any>()
          };          
        }
      });

    }

  }

  onAddLocation() {
    this.currentConfiguration.contentLocations.push({
      id: 0,
      name: this.currentLocationName
    });

    this.currentLocationName = "";
  }

  onContentLocation(location) {
    this.selectedLocation = location;

    this._adminService.getDocsFromMediaContainer(this.currentProject.projectShortName, location.name, this.currentProject.apiKey) 
      .subscribe(response => {
        console.log('docs loaded...', response);
        this.docsCollection = new Array();
        for(var itm in response) {
          var path = environment.docs_url + this.currentProject.projectShortName + "/" + location.name + "/" + response[itm];
          this.docsCollection.push({ 
            "name": response[itm],
            "url": path
          });
        }
    });
    
  }

  onSubscriptionAdded(event) {
    this.isSaving = true;

    this._adminService.addSubscription(event).subscribe(response => {                 
      this.currentProject.id = response["id"];
      this.currentProject.apiKey = response["apiKey"];

      this._alertify.success("Subscription was created.");
      this.isSaving = false;

    }, error => {
      this._alertify.error(error);
      this.isSaving = false;
    });

  }

  onSave() {
    console.log('saving...', this.currentProject, this.currentConfiguration);
    this._adminService.saveDocsConfiguration(this.currentProject.projectShortName, this.currentProject.apiKey, this.currentConfiguration)  
      .subscribe(response => {
        console.log('saved...', response);
        this.currentConfiguration.id = response["id"];

        this.currentConfiguration.contentLocations = response["contentLocations"];
    });
  }


}

